export const capitalizeFirstLetter = (string: string | null | undefined): string => {
  if (!string) {
    return ''; // or return a default value, or handle it as per your need
  }
  return string.charAt(0).toUpperCase() + string.slice(1);
};
